export default __webpack_public_path__ + "static/media/heart.86117d8e.svg";